import { useDatatablesServerSide } from "App/hooks";
import { defaultToastError } from "App/utils/helpers";
import { useContext, useState } from "react";
import { changeLoadingLokasi, changeLokasi } from "../../context/actions";
import { OrganisasiCtx } from "../../context/context";
import { getLokasi, RESET_STATE_LOKASI } from "../helpers";

function useReloadTableLokasi() {
	const { state, dispatch } = useContext(OrganisasiCtx);

	const [formFilter, setFormFilter] = useState(RESET_STATE_LOKASI);
	const handleChange = (text) => (e) => {
		setFormFilter({
			...formFilter,
			[text]: e.target.value,
		});
	};

	const setNewData = async (
		pages = formFilter.pages,
		limit = formFilter.limit,
		formSearch = formFilter
	) => {
		dispatch(changeLoadingLokasi(true));
		const response = await getLokasi(formSearch, pages, limit);
		if (response.state) {
			dispatch(
				changeLokasi({
					status: response.status,
					message: response.message,
					body: response.body,
					count: response.count,
					sisa: response.sisa,
					limit: response.limit,
					pages: response.pages,
				})
			);
			dispatch(changeLoadingLokasi(false));
			// defaultToastSuccess(response.message);
		} else {
			dispatch(
				changeLokasi({
					status: "",
					message: "",
					body: [],
					count: 1,
					sisa: true,
					limit: 10,
					pages: 1,
				})
			);
			dispatch(changeLoadingLokasi(false));
			defaultToastError(response.message);
		}
	};

	const {
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	} = useDatatablesServerSide({
		setNewData: setNewData,
		additionalProps: formFilter,
	});

	return {
		setNewData,
		loading: state.loadingLokasi,
		handleChange,
		formFilter,
		setFormFilter,
		pagination,
		onNext,
		onPrevious,
		handleClickPageNumber,
		handleChangeLimit,
		resetPagination,
	};
}

export default useReloadTableLokasi;
